import { LIMPIAR_DATOS_LISTA_BENEFICIARIOS, LIMPIAR_DATOS_LISTA_GENERAL_ENDOSOS, LISTA_BENEFICIARIOS_HAS_ERRORED, LISTA_BENEFICIARIOS_LOADING, LISTA_GENERAL_ENDOSOS_HAS_ERRORED, LISTA_GENERAL_ENDOSOS_LOADING, SET_DATA_LISTA_BENEFICIARIOS, SET_DATA_LISTA_GENERAL_ENDOSOS } from "../actions/aEndososBeneficiarios";

export const LISTA_ENDOSOS_HAS_ERRORED = "LISTA_ENDOSOS_HAS_ERRORED";
export const SET_DATA_LISTA_ENDOSOS = "SET_DATA_LISTA_ENDOSOS";
export const SET_DATA_LISTA_RAMOS = "SET_DATA_LISTA_RAMOS";
export const LISTA_ENDOSOS_LOADING = "LISTA_ENDOSOS_LOADING";
export const LIMPIAR_DATOS_LISTA_ENDOSOS = "LIMPIAR_DATOS_LISTA_ENDOSOS";


const initialStateEndosos = {
  isLoadingEndosos: false,
  hasErroredEndosos: false,
  datosEndosos: [],
  datosEndososGenerales:[],
  hasErroredEndososGenerales:false
};


export function dataEndosos(state = initialStateEndosos, action) {
  switch (action.type) {
    case LISTA_ENDOSOS_LOADING:
      return {
        ...state,
        isLoadingEndosos: true,
        hasErroredEndosos: false
      };
    case SET_DATA_LISTA_ENDOSOS:
      return {
        ...state,
        datosEndosos: action.payload,
      };
    case LISTA_ENDOSOS_HAS_ERRORED:
      return {
        ...state,
        isLoadingEndosos: false,
        hasErroredEndosos: true
      };
    case LIMPIAR_DATOS_LISTA_ENDOSOS:
      return {
        ...state,
        isLoadingEndosos: false,
        hasErroredEndosos: false,
        datosEndosos: [],
        datosFiltro: []
      };

    case LISTA_GENERAL_ENDOSOS_LOADING:
      return {
        ...state,
        isLoadingEndosos: true,
        hasErroredEndososGenerales: false
      };
    case SET_DATA_LISTA_GENERAL_ENDOSOS:
      return {
        ...state,
        datosEndososGenerales: action.payload,
      };
    case LISTA_GENERAL_ENDOSOS_HAS_ERRORED:
      return {
        ...state,
        isLoadingEndosos: false,
        hasErroredEndososGenerales: true
      };
    case LIMPIAR_DATOS_LISTA_GENERAL_ENDOSOS:
      return {
        ...state,
        isLoadingEndosos: false,
        hasErroredEndososGenerales: false,
        datosEndososGenerales: []
      };

    default:
      return state;
  }
}

const initialStateBeneficiarios = {
  isLoadingBeneficiarios: false,
  hasErroredBeneficiarios: false,
  datosBeneficiarios: []
};

export function dataBeneficiariosEndosos(state = initialStateBeneficiarios, action) {
  switch (action.type) {
    case LISTA_BENEFICIARIOS_LOADING:
      return {
        ...state,
        isLoadingBeneficiarios: true,
        hasErroredBeneficiarios: false
      };
    case SET_DATA_LISTA_BENEFICIARIOS:
      return {
        ...state,
        datosBeneficiarios: action.payload,
      };
    case LISTA_BENEFICIARIOS_HAS_ERRORED:
      return {
        ...state,
        isLoadingBeneficiarios: false,
        hasErroredBeneficiarios: true
      };
    case LIMPIAR_DATOS_LISTA_BENEFICIARIOS:
      return {
        ...state,
        isLoadingBeneficiarios: false,
        hasErroredBeneficiarios: false,
        datosBeneficiarios: [],
        datosFiltro: []
      };

    default:
      return state;
  }
}